// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1HZPJ","label":"styles_label__zUC4J"};